"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const lucide_react_1 = require("lucide-react");
const staticIcons = {
    "arrow-up-right": lucide_react_1.ArrowUpRight,
    "arrow-right": lucide_react_1.ArrowRight,
    "arrow-left": lucide_react_1.ArrowLeft,
    "arrow-down": lucide_react_1.ArrowDown,
    "move-left": lucide_react_1.MoveLeft,
    "map-pin": lucide_react_1.MapPin,
    x: lucide_react_1.X,
    facebook: lucide_react_1.Facebook,
    instagram: lucide_react_1.Instagram,
};
exports.Icon = react_1.default.memo(({ name, size = 20, color = "currentColor", ...props }) => {
    const IconComponent = staticIcons[name];
    if (!IconComponent) {
        console.warn(`Icon "${name}" not found. Ensure it is imported in the staticIcons mapping.`);
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(IconComponent, { className: "smzh-icon", "data-component-id": "CO18", size: size, color: color, "aria-hidden": !props["aria-label"] && !props["role"] ? "true" : undefined, ...props }));
});
